/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { adminRoutes } from './adminRoutes';

export enum StructuralPageTypes {
  project = 'project',
  organization = 'organization',
  cluster = 'cluster',
  admin = 'admin',
}

export const BasicRoutes = {
  SETUP: '/setup',
  LOGIN: '/login',
  SIGN_UP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  EMAIL_VERIFICATION: '/email-verification/:token',
  RECOVERY_PASSWORD: '/recovery-password/:token',
  CONFIRM_PASSWORD_RESET: '/confirm/password/reset',
  SSO_CALLBACK: '/sso/callback',

  HOME: '/',
  ABOUT: '/about',
  IMPRINT: '/imprint',
  PROFILE: '/profile',
  ORGANIZATIONS: '/organizations',
  INVITATIONS: '/invitations',
  SUPPORT: '/support',
  ADMIN: `/${StructuralPageTypes.admin}`,
  ORGANIZATION_PAGE: `/${StructuralPageTypes.organization}/:organization_id`,
  MANAGE_ORGANIZATION: `/${StructuralPageTypes.organization}/:organization_id/manage`,
  MANAGE_TEAM: `/${StructuralPageTypes.organization}/:organization_id/manage/teams/:team_identifier`,
  PROJECT_PAGE: `/${StructuralPageTypes.organization}/:organization_id/${StructuralPageTypes.project}/:project_id`,
  MANAGE_PROJECT: `/${StructuralPageTypes.organization}/:organization_id/${StructuralPageTypes.project}/:project_id/manage`,
  CLUSTER_PAGE: `/${StructuralPageTypes.organization}/:organization_id/${StructuralPageTypes.project}/:project_id/${StructuralPageTypes.cluster}/:cluster_id`,
  CLUSTER_DATASETS_PAGE: `/${StructuralPageTypes.organization}/:organization_id/${StructuralPageTypes.project}/:project_id/${StructuralPageTypes.cluster}/:cluster_id/datasets`,
  CREATE_CLUSTER: '/create',

  ADMIN_HOME: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_HOME}`,
  ADMIN_USERS: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_USERS}`,
  ADMIN_ENQUIRIES: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_ENQUIRIES}`,
  ADMIN_DATASETS: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_DATASETS}`,
  ADMIN_DATASETS_CATEGORIES: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_DATASETS_CATEGORIES}`,
  ADMIN_SYSTEM_CONFIG: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_SYSTEM_CONFIG}`,
  ADMIN_EMAIL_CONFIG: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_EMAIL_CONFIG}`,
  ADMIN_IMPRINT_CONFIG: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_IMPRINT_CONFIG}`,
  ADMIN_SUPPORT_CONFIG: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_SUPPORT_CONFIG}`,
  ADMIN_SEND_EMAIL: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_SEND_EMAIL}`,
  ADMIN_ORGANIZATIONS: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_ORGANIZATIONS}`,
  ADMIN_CLUSTERS_ORPHANS: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_CLUSTERS_ORPHANS}`,
  ADMIN_MANAGE_PLANS_STORAGE: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_MANAGE_PLANS_STORAGE}`,
  ADMIN_MANAGE_PLANS_COMPUTE: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_MANAGE_PLANS_COMPUTE}`,
  ADMIN_MANAGE_PLANS_SUPPORT: `/${StructuralPageTypes.admin}${adminRoutes.ADMIN_MANAGE_PLANS_SUPPORT}`,
};
